import { render, staticRenderFns } from "./LoanCardDetail.vue?vue&type=template&id=c90f53ee&"
import script from "./LoanCardDetail.vue?vue&type=script&lang=js&"
export * from "./LoanCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanCardDetail.vue?vue&type=style&index=0&id=c90f53ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports